// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2MyDf","title":"BackImages_title__AdfJB","images":"BackImages_images__n13gI"};